import { Label, Icon } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { getInventoryName } from '../utils';
import useAppContext from '../../../../../context/useAppContext';
import css from '../../styles.module.css';

export default function SelectedInventories({ form, bookingSelectionAuto, onDeleteInventory = () => {}, onClearInventories = () => {} }) {
    const { t } = useTranslation();
    const [{ event }] = useAppContext();

    if (form.inventories.length && bookingSelectionAuto) {
        return (
            <>
                <div className={css['rates-manager-container']}>
                    <div className={css['rates-manager-delete-all']} onClick={onClearInventories}>
                        <span>{/* must remain empty for alignment purposes */}</span>
                        <span>
                            <Icon name="trash" size="regular" />
                            {t('attendees.addAttendees.selectHierarchy.deleteInventories')}
                        </span>
                    </div>

                    {form.inventories.map(selected_inventory => {
                        return (
                            <Label className={css['selected-inventories-labels']} key={selected_inventory.pk} nameIcon="delete">
                                <span>{getInventoryName(event.isFakeSeating(), selected_inventory, event.timezone)}</span>
                                <Icon name={'cross'} onClick={() => onDeleteInventory(selected_inventory.pk)} />
                            </Label>
                        );
                    })}
                </div>
            </>
        );
    }

    return null;
}
